import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import Layout from "../components/Layout";
import { api } from "../lib/api";

export default function Reschedule() {
  const [phone, setPhone] = useState("");
  const [bookings, setBookings] = useState(null);
  const [sel, setSel] = useState(null);
  const [days, setDays] = useState([]);
  const [newDate, setNewDate] = useState("");
  const [newSlot, setNewSlot] = useState("");
  const [fee, setFee] = useState(null);

  useEffect(() => {
    const start = new Date().toISOString().slice(0, 10);
    api.get(`/availability?start=${start}&days=35`).then((r) => setDays(r.data.days));
  }, []);

  const digits = phone.replace(/\D/g, "");
  const lookup = async () => {
    if (digits.length !== 10) return toast.error("Enter your 10-digit phone number.");
    const { data } = await api.get(`/my-bookings?phone=${digits}`);
    setBookings(data.bookings); setSel(null);
    if (!data.bookings.length) toast.error("No upcoming bookings found for that number.");
  };
  const pick = async (b) => {
    setSel(b); setNewDate(""); setNewSlot("");
    try { const { data } = await api.get(`/reschedule-fee?booking_id=${b.id}&phone=${digits}`); setFee(data.fee); } catch { setFee(null); }
  };
  const submit = async () => {
    if (!newDate || !newSlot) return toast.error("Pick a new day and time.");
    try {
      const { data } = await api.patch("/reschedule", { booking_id: sel.id, phone: digits, new_date: newDate, new_slot: newSlot });
      toast.success(data.message);
      setSel(null); setBookings(null); setPhone("");
    } catch (e) { toast.error(e.response?.data?.detail || "Could not reschedule."); }
  };

  return (
    <Layout>
      <section className="max-w-2xl mx-auto px-6 py-16 md:py-24">
        <p className="text-xs tracking-[0.3em] uppercase text-pink-500 font-bold mb-4">Manage Booking</p>
        <h1 className="text-4xl md:text-6xl font-extrabold tracking-tighter">Reschedule a detail</h1>
        <p className="text-zinc-400 mt-4">Enter the phone number on your booking to look it up. Fees: 24hrs+ before <strong>$0</strong>, 12hrs <strong>$20</strong>, 5hrs <strong>$30</strong>, 3hrs <strong>$50</strong>.</p>

        <div className="mt-8 flex gap-2">
          <input value={phone} onChange={(e) => setPhone(e.target.value)} placeholder="Phone number (10 digits)" inputMode="tel" className="flex-1 bg-[#050505] border border-white/20 focus:border-pink-500 rounded-lg px-4 py-3 outline-none" data-testid="resched-phone" />
          <button onClick={lookup} className="bg-pink-600 hover:bg-pink-500 rounded-full px-6 py-3 font-semibold transition-colors" data-testid="resched-lookup">Find booking</button>
        </div>

        {bookings && bookings.map((b) => (
          <button key={b.id} onClick={() => pick(b)} className={`mt-3 w-full text-left rounded-2xl border p-5 transition-all ${sel?.id === b.id ? "border-pink-500 bg-[#1a1013]" : "border-white/10 bg-[#121212] hover:border-white/25"}`} data-testid={`resched-booking-${b.id}`}>
            <p className="font-bold">{b.full_name} · {b.date}</p>
            <p className="text-sm text-zinc-400">{b.time_slot} · {b.status.replace("_", " ")}</p>
          </button>
        ))}

        {sel && (
          <div className="mt-8">
            {fee !== null && (
              <div className={`rounded-xl border p-4 text-sm mb-4 ${fee > 0 ? "border-amber-500/40 bg-amber-500/10 text-amber-200" : "border-green-500/40 bg-green-500/10 text-green-200"}`} data-testid="resched-fee">{fee > 0 ? `A $${fee} reschedule fee applies for this notice window.` : "No reschedule fee — you're giving 24+ hours notice."}</div>
            )}
            <p className="text-sm font-semibold mb-2">Pick a new day</p>
            <div className="grid grid-cols-4 sm:grid-cols-7 gap-2 max-h-56 overflow-y-auto">
              {days.map((d) => {
                const dt = new Date(d.date + "T00:00:00");
                return (
                  <button key={d.date} disabled={d.blocked} onClick={() => { setNewDate(d.date); setNewSlot(""); }} className={`rounded-xl border p-2 text-center transition-all ${d.blocked ? "opacity-25 cursor-not-allowed border-white/10" : newDate === d.date ? "border-pink-500 bg-[#1a1013]" : "border-white/10 hover:border-white/30"}`} data-testid={`resched-date-${d.date}`}>
                    <p className="text-[10px] text-zinc-500">{dt.toLocaleDateString("en-US", { weekday: "short" })}</p>
                    <p className="text-sm font-bold">{dt.getDate()}</p>
                  </button>
                );
              })}
            </div>
            {newDate && (
              <div className="mt-4 flex flex-wrap gap-2">
                {(days.find((d) => d.date === newDate)?.slots || []).map((sname) => (
                  <button key={sname} onClick={() => setNewSlot(sname)} className={`rounded-full px-4 py-2 text-sm ${newSlot === sname ? "bg-pink-600" : "bg-white/5 border border-white/15"}`} data-testid={`resched-slot-${sname}`}>{sname}</button>
                ))}
              </div>
            )}
            <button onClick={submit} className="mt-6 bg-pink-600 hover:bg-pink-500 rounded-full px-8 py-3 font-semibold transition-colors active:scale-95" data-testid="resched-submit">Confirm reschedule</button>
          </div>
        )}
      </section>
    </Layout>
  );
}
